// extracted by mini-css-extract-plugin
export default {"wrapper":"searchbar-module__wrapper___DFspw","icon":"searchbar-module__icon___ENeHQ","field":"searchbar-module__field___N0oFP"};